module.exports = __webpack_public_path__ + "static/img/SSDHighlightVideo_MaximeGoualin_Still.cb319e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/SSDHighlightVideo_MaximeGoualin_Still.jpg
// module id = 47Ek
// module chunks = 0